/**
 * 申請要求処理
 */
// tslint:disable-next-line:no-namespace
export namespace ApplicationProcessType {
    /** 新規申請 */
    export const NEW = '1';
    /** 申請書修正 */
    export const CORRECT = '2';
    /** 申請書確認 */
    export const CHECK = '3';
    /** 変更申請 */
    export const CHANGE = '4';
    /** 継続申請 */
    export const CONTINUE = '5';
    // 2025/8/22 [R7年度改修作業（PKGエンハンス適用）] add start
    /** 申請取消 */
    export const CANCEL = '8';
    // 2025/8/22 [R7年度改修作業（PKGエンハンス適用）] add end
}
